import { render, staticRenderFns } from "./TableCom.vue?vue&type=template&id=2da1507c&scoped=true"
import script from "./TableCom.vue?vue&type=script&lang=js"
export * from "./TableCom.vue?vue&type=script&lang=js"
import style0 from "./TableCom.vue?vue&type=style&index=0&id=2da1507c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1507c",
  null
  
)

export default component.exports